import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Theme, makeStyles, useTheme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { ForgotPasswordGrid } from './ForgotPasswordGrid';
import { VseAlertContainer } from '../alert/VseAlertContainer';
import * as PasswordReset from '../../features/password';
import * as VseAlert from '../../features/alert';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  paper: {
    margin: 'auto',
    padding: theme.spacing(2),
  },
}));

export function ForgotPasswordPage() {

  const theme = useTheme();
  const classes = useStyles(theme);
  const succeeded = (
    <div>
      <Typography variant='h6'>Reset Password</Typography>
      <Typography variant='body1'>
        An email has been sent to your email address. Click on the link in the email and follow instructions to reset your password.
      </Typography>
    </div>
  );
  const passwordResetState = PasswordReset.usePasswordResetState();
  const dispatch = useDispatch();

  React.useEffect(function init() {
    return function reset() {
      dispatch(PasswordReset.reset())
      dispatch(VseAlert.dismissValidationProblem());
    }
  }, [dispatch]);

  React.useEffect(() => {
    if (passwordResetState.loading === 'succeeded') {
      dispatch(VseAlert.dismissValidationProblem());
    }
  }, [dispatch, passwordResetState.loading]);

  return (
    <main className={classes.root}>
      <VseAlertContainer />
      <Paper className={classes.paper}>
        {passwordResetState.loading === 'succeeded' ? (
          succeeded
        ) : (
            <ForgotPasswordGrid onSubmit={(userName) => dispatch(PasswordReset.forgotPassword(userName))} />
          )}
      </Paper>
    </main>
  );
}
